import { render, staticRenderFns } from "./EmailPhoneColumn.vue?vue&type=template&id=5e14d853&"
import script from "./EmailPhoneColumn.vue?vue&type=script&lang=js&"
export * from "./EmailPhoneColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports